import { SharedFunnelService } from './../../../../../components/user-dashboard/funnel/shared-funnel.service';

import {
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { Router } from '@angular/router';
import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../services/learmo-modal.service';
import { ToastrService } from 'ngx-toastr';
import {
  FormSubscriber,
  FormSubscriberStatusEnum,
} from 'src/app/models/funnels';

@Component({
  selector: 'app-subscriber-item-popup',
  templateUrl: './subscriber-item-popup.component.html',
  styleUrls: ['./subscriber-item-popup.component.css'],
})
export class SubscriberItemPopupComponent implements OnInit {
  formSubscriberStatusEnum = FormSubscriberStatusEnum;
  @Input() subscriberItem: FormSubscriber;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  constructor(
    public sharedFunnelService: SharedFunnelService,
    private modalService: LearmoModalService,
    private route: Router,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {}

  closeModal() {
    this.modalRef.close();
  }
  // Affiliate Links List

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    const title = this.subscriberItem?.firstName
      ? `${this.subscriberItem.firstName} Details`
      : 'Subscriber Details';

    this.modalRef = this.modalService.open(this.modalContent, {
      title: title,
      icon: 'user', // Lucide icon
      size: 'lg',
      premium: true,
    });
  }

  async onOpenModal() {
    // this.resetForm();
    // this.productObject.type_id = 1;
  }

  // FileUpload
}
